import React from 'react';
    import NavbarComponent from './Navbar';
    import Footer from './footer';
    import { Switch, Route } from 'react-router-dom';
        import Map1 from './Map';
        import IssView from './Streetview';
        import Live from './Live';
        import Minigame from './Minigame'
        import gamePlanet from './gamePlanet'
        import pictureOfDay from './pictureOfDay'
        import Quizz from './Quiz'
        import Resium from './cesium/Resium';
class Router extends React.Component {

    render(){
        return(
            <>
            <NavbarComponent />
                <div className="mainContainer">
            <Switch>
                <Route exact path="/" component={Map1} />
                <Route exact path="/GamePlanet" component={gamePlanet} />
                <Route exact path="/IssView" component={IssView} />
                <Route exact path="/Live" component={Live} />
                <Route exact path="/Minigame" component={Minigame} />
                <Route exact path="/pictureOfDay" component={pictureOfDay} /> 
                <Route exact path="/Quiz" component={Quizz} />
                <Route exact path="/map3D" component={Resium} />
            </Switch>
            </div>
            <Footer/>
    </>
        );
    }
}
export default Router;